import {defaultTheme} from '@stencil/build-theme';

const colors = defaultTheme.colors;

export const ratingColorMap = [
  colors.goRed.base,
  colors.goYellow.dark,
  colors.goGreen.medium,
  colors.goGreen.base,
  colors.goTeal.dark,
];

// 🐨: replace Array<string> with Array<hex value from CSStypes>
export const ratingColorSelector = (rating: number, ratingMap: Array<string> = ratingColorMap) => {
  if (rating >= 1 && rating <= 1.9) {
    return ratingMap[0];
  }

  if (rating >= 2 && rating <= 2.9) {
    return ratingMap[1];
  }

  if (rating >= 3 && rating <= 3.9) {
    return ratingMap[2];
  }

  if (rating >= 4 && rating <= 4.4) {
    return ratingMap[3];
  }

  if (rating >= 4.5 && rating <= 5) {
    return ratingMap[4];
  }
};
